import React from 'react'
import { ContestType, PaginaType } from 'utils/types'
import useTrans from '@hooks/useTrans'
import { WContainer } from '@components/atoms'
import { EmptyMessageBox, EventoCard } from '@components/molecules'
import { Page } from '@components/organisms'
import styles from './ListingEventiTemplate.module.sass'

interface Props {
  pagina: PaginaType
  contests: [ContestType]
}

const ListingEventiTemplate = (props: Props) => {
  const { contests, pagina } = props
  const t = useTrans()

  const attivi = contests.filter((c) => !c.toDate || new Date(c.toDate) > new Date())
  const terminati = contests.filter((c) => c.toDate && new Date(c.toDate) < new Date())

  return (
    <Page pagina={pagina} item={contests}>
      <div className={styles.listingEventiTemplate}>
        <WContainer>
          {(!!pagina.titolo || !!pagina.descrizione) && (
            <div className={styles.head}>
              {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
              {!!pagina.descrizione && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
                />
              )}
            </div>
          )}

          {contests?.length > 0 ? (
            <>
              <div className={styles.list}>
                {attivi.map((item, key) => (
                  <div className={styles.item} key={item.title}>
                    <EventoCard contest={item} priority={key === 0} />
                  </div>
                ))}
              </div>
              <h2 className={styles.terminatiTitle}>
                {t('Concorsi e operazioni a premio terminati')}
              </h2>
              <div className={styles.list}>
                {terminati.map((item) => (
                  <div className={styles.item} key={item.title}>
                    <EventoCard contest={item} />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <EmptyMessageBox
              item={{
                name: t('Vuoi essere sempre il primo a saperlo?'),
                description: t(
                  'Iscriviti alla newsletter per essere sempre aggiornato sugli ultimi eventi e concorsi di Mellin'
                ),
                ctaLabel: t('Iscriviti alla newsletter'),
                url: '/registrazione',
              }}
              className={styles.empty}
            />
          )}
        </WContainer>
      </div>
    </Page>
  )
}

export default ListingEventiTemplate
